import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { format, eachDayOfInterval, startOfMonth, endOfMonth, eachMonthOfInterval, startOfYear, endOfYear, getDay } from "date-fns";
import { DefaultLayout } from "../../layouts/Default";
import { TopNavigation } from "../../themes/Default/components/TopNavigation";
import { Title } from "../../themes/Default/components/Title";
import { Breadcrumps } from "../../themes/Default/components/Breadcrumps";
import { Link } from "../../themes/Default/components/Breadcrumps/components/Link";
import { Main } from "../../themes/Default/components/Main";
import { Tabs } from "../../themes/Default/components/Tabs";
import { Wizard } from "../../themes/Default/components/Wizard";
import { Step } from "../../themes/Default/components/Wizard/Step";
import { ButtonBack, Button } from "../../themes/Default/components/TopNavigation/components/Button";
import { Calendar } from "../../themes/Default/components/Calendar";
import { Month } from "../../themes/Default/components/Calendar/components/Month";
import { Day, DayOffset } from "../../themes/Default/components/Calendar/components/Month/components/Day";
import { groupsManagement } from "../../hooks/api/GroupsManagement";
import { Formik } from "formik";
import { Form } from "../../themes/Default/components/Form";
import { Row } from "../../themes/Default/components/Form/components/Row";
import { Field } from "../../themes/Default/components/Form/components/Row/components/Field";
import { Input } from "../../themes/Default/components/Form/components/Input";
import { useTranslation } from "react-i18next";
import { useViewGroupMutation } from "../../hooks/api/GroupsManagement/GroupsManagement";
import { Slide, toast, ToastContainer } from "react-toastify";
import TimePicker from "../../themes/Default/components/Form/components/TimePicker/TimePicker";
import { calendarHolidaysManagement } from "../../hooks/api/CalendarHolidaysManagement";
import { Toaster } from "../../themes/Default/components/Toaster";
import DatePicker from "../../themes/Default/components/Form/components/DatePicker/DatePicker";

const AddBulkCalendar = () => {
    const { t } = useTranslation("common");
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState([]);
    const formRef = useRef(null);
    const [dates, setDates] = useState([]);
    const [totalSelectedDates, setTotalSelectedDates] = useState([]);
    const [classNumber, setClassNumber] = useState([]);
    const [startDate, setStartDate] = useState();
    console.log(startDate);
    const [endDate, setEndDate] = useState();
    const { groupId } = useParams();
    const [months, setMonths] = useState([]);
    const [groupName, setGroupName] = useState("");
    const [isStarted, setIsStarted] = useState([]);
    const {
        useAddGroupDatesMutation,
        useListGroupDatesMutation,
        useViewGroupDateMutation,
        useDeleteGroupDateMutation,
        useViewGroupMutation,
        useStartGroupMutation,
        useCanGroupStartMutation,
    } = groupsManagement;

    const [addGroupDates] = useAddGroupDatesMutation();
    const [listGroupDates] = useListGroupDatesMutation();
    const [viewGroupDate] = useViewGroupDateMutation();
    const [deleteGroupDate] = useDeleteGroupDateMutation();
    const [viewGroup] = useViewGroupMutation();
    const [holidays, setHolidays] = useState();
    const { useCalendarHolidaysListMutation } = calendarHolidaysManagement;
    const [holidayList, { isLoading }] = useCalendarHolidaysListMutation();
    const [selectedWeekdays, setSelectedWeekdays] = useState([]);
    const [canGroupStart] = useCanGroupStartMutation();
    const [startGroup, setStartGroup] = useState(true);
    const [groupStart] = useStartGroupMutation();

    const tabs = [
        ...(isStarted
            ? [
                  { title: t("groups.attendance"), onClick: () => gotoAttendanceTab(groupId) },
                  { title: t("groups.planning"), onClick: () => gotoPlanningTab(groupId) },
                  { title: t("groups.progress"), onClick: () => gotoProgressTab(groupId) },
                  { title: t("groups.progressTest"), onClick: () => gotoProgressTestTab(groupId) },
                  { title: t("reports.title"), onClick: () => gotoReportTab(groupId) },
                  { title: t("documents"), onClick: () => gotoDocumentsTab(groupId) },
                  { title: t("notes"), onClick: () => gotoNotesTab(groupId) },
              ]
            : []),
        { title: t("settings.title"), link: "/settings/reports", isActive: true },
    ];

    const gotoPlanningTab = (groupId) => {
        navigate("/groups/" + groupId + "/planning");
    };

    const gotoReportTab = (groupId) => {
        navigate("/groups/" + groupId + "/reports");
    };

    const gotoProgressTestTab = (groupId) => {
        navigate("/groups/" + groupId + "/tests");
    };

    const gotoProgressTab = (groupId) => {
        navigate("/groups/" + groupId + "/progress");
    };

    const gotoNotesTab = (groupId) => {
        navigate("/groups/" + groupId + "/notes");
    };

    const gotoDocumentsTab = (groupId) => {
        navigate("/groups/" + groupId + "/documents");
    };

    const gotoAttendanceTab = (groupId) => {
        navigate("/groups/" + groupId + "/attendance");
    };

    const gotoCalendarStep = () => {
        navigate("/groups/" + groupId + "/calendar/add");
    };

    const toggleWeekday = (dayIndex) => {
        setSelectedWeekdays((prev) => (prev.includes(dayIndex) ? prev.filter((d) => d !== dayIndex) : [...prev, dayIndex]));
    };

    const onSave = (dateId, date) => {
        viewGroupDate({ dateId, groupId }).then((result) => {
            if (result?.data?.id) {
                toast.warn(
                    ({ closeToast }) => (
                        <Toaster
                            closeToast={closeToast}
                            description={t("areYouSure")}
                            optionNo={t("no")}
                            optionYes={t("yes")}
                            onClick={() => {
                                closeToast();
                                deleteGroupDate({ dateId, groupId }).then((result) => {
                                    if (result?.error) {
                                        setFormErrors(result?.error?.data?.error?.violations);
                                        toast.error(result?.error?.data?.error?.responseMessage);
                                    } else {
                                        toast.info(result?.data?.info?.responseMessage);
                                        loadMonths();
                                    }
                                });
                            }}
                        />
                    ),
                    {
                        autoClose: false,
                        progress: false,
                        closeButton: false,
                    },
                );
            } else {
                const body = {
                    dates: [
                        {
                            date: date,
                            timeFrom: formRef.current.values.timeFrom,
                            timeTo: formRef.current.values.timeTo,
                        },
                    ],
                };
                addGroupDates({ body, groupId }).then((result) => {
                    if (result?.error) {
                        setFormErrors(result?.error?.data?.error?.violations);
                        toast.error(result?.error?.data?.error?.responseMessage);
                    } else {
                        toast.info(result?.data?.info?.responseMessage);
                        loadMonths();
                    }
                });
            }
        });
    };

    const monthNames = [
        t("calendar.january"),
        t("calendar.february"),
        t("calendar.march"),
        t("calendar.april"),
        t("calendar.may"),
        t("calendar.june"),
        t("calendar.july"),
        t("calendar.august"),
        t("calendar.september"),
        t("calendar.october"),
        t("calendar.november"),
        t("calendar.december"),
    ];

    const weekDays = ["P", "U", "S", "Č", "P", "S", "N"];

    const isCancel = (dateId) => {
        return dates.some((date) => date.id === dateId && date.isCancel === true);
    };

    const loadMonths = () => {
        listGroupDates(groupId).then((result) => {
            setDates(result?.data?.records);
            const months = eachMonthOfInterval({
                start: startOfMonth(startDate),
                end: endOfMonth(endDate),
            });
            setMonths(months);
            setTotalSelectedDates(result?.data?.totalRecords);
        });
    };

    const checkHoliday = (selectedDate) => {
        holidays.forEach((holiday) => {
            if (holiday.date === selectedDate) {
                toast.error(
                    <>
                        Izabrali ste praznik <br />
                        {holiday.title}
                    </>,
                );
            }
        });
    };

    const generateSelectedDates = (totalDays) => {
        if (!startDate || selectedWeekdays.length === 0 || !totalDays) return [];

        const selectedDates = [];
        let currentDate = new Date(startDate);

        while (selectedDates.length < totalDays) {
            const dayIndex = getDay(currentDate) === 0 ? 6 : getDay(currentDate) - 1;
            if (selectedWeekdays.includes(dayIndex)) {
                selectedDates.push(new Date(currentDate));
            }
            currentDate.setDate(currentDate.getDate() + 1);
        }

        return selectedDates;
    };

    const handleBulkSave = () => {
        const selectedDates = generateSelectedDates(5);

        if (selectedDates.length === 0) {
            toast.error("Morate odabrati dane i raspon datuma.");
            return;
        }

        const formattedDates = selectedDates.map((date) => ({
            date: format(date, "yyyy-MM-dd"),
            timeFrom: formRef.current.values.timeFrom,
            timeTo: formRef.current.values.timeTo,
        }));

        const body = { dates: formattedDates };

        addGroupDates({ body, groupId }).then((result) => {
            if (result?.error) {
                setFormErrors(result?.error?.data?.error?.violations);
                toast.error(result?.error?.data?.error?.responseMessage);
            } else {
                toast.info(result?.data?.info?.responseMessage);
                loadMonths();
            }
        });
    };

    useEffect(() => {
        holidayList().then((result) => {
            const holidays = result?.data?.records;
            setHolidays(holidays);
        });
    }, [holidayList]);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <Button title={""} icon="fa-regular fa-arrow-left-from-line" onClick={gotoCalendarStep}></Button>
                <Button title={"Sacuvaj datume"} icon="fa-regular fa-play" onClick={handleBulkSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Title fullWidth={"100%"}>
                    {groupName}
                    <span className="numOfClasses">
                        Number of classes:{" "}
                        <span className="numOfClassesFrstNum" style={totalSelectedDates < classNumber ? { color: "#EB5757" } : {}}>
                            {totalSelectedDates > classNumber ? classNumber : totalSelectedDates}
                        </span>
                        <span className="numOfClassesScndNum">/{classNumber}</span>
                    </span>
                </Title>
                <Breadcrumps>
                    <Link title={t("groups.title")} icon="fa-light fa-users" />
                    <Link title={t("details")} isActive={true} />
                </Breadcrumps>
                <br />
                <Formik
                    innerRef={formRef}
                    initialValues={{
                        date: "",
                        timeFrom: "",
                        timeTo: "",
                    }}
                    onSubmit={onSave}
                >
                    {({ handleChange, values }) => (
                        <Form>
                            <Row>
                                <Field>
                                    <TimePicker
                                        name="timeFrom"
                                        label={t("calendar.timeFrom")}
                                        required={true}
                                        value={values.timeFrom}
                                        onChange={handleChange}
                                        error={formErrors?.timeFrom}
                                    />
                                </Field>
                                <Field>
                                    <TimePicker
                                        name="timeTo"
                                        label={t("calendar.timeTo")}
                                        required={true}
                                        value={values.timeTo}
                                        onChange={handleChange}
                                        error={formErrors?.timeTo}
                                    />
                                </Field>
                            </Row>
                        </Form>
                    )}
                </Formik>
                <br />
                <br />
                <Row>
                    <Field>
                        <DatePicker
                            name="startDate"
                            label={"Start date"}
                            required={true}
                            value={""}
                            onChange={(e) => setStartDate(new Date(e.target.value))}
                            error={formErrors?.date}
                        />
                    </Field>
                    {/* <Field>
                        <DatePicker
                            name="endDate"
                            label={"End date"}
                            required={true}
                            value={""}
                            onChange={(e) => setEndDate(new Date(e.target.value))}
                            error={formErrors?.date}
                        />
                    </Field> */}
                </Row>
                <Row>
                    <Field>
                        <div className="bulkCalendar__label">Dani u nedelji</div>
                        <div className="bulkCalendar__days">
                            {weekDays.map((dayLabel, index) => (
                                <div
                                    key={index}
                                    className={`bulkCalendar__day ${index >= 5 ? "weekend" : ""} ${selectedWeekdays.includes(index) ? "active" : ""}`}
                                    onClick={() => toggleWeekday(index)}
                                >
                                    {dayLabel}
                                </div>
                            ))}
                        </div>
                    </Field>
                </Row>
            </Main>
        </DefaultLayout>
    );
};

export default AddBulkCalendar;
